import { handleActions } from 'redux-actions';
import produce from 'immer';
import actions from './actions';
import {
  BALANCE_SUMMARY_BOX_MODEL,
  BALANCE_LIST_SEARCH_DATA_MODEL,
  BALANCE_LIST_SEARCH_OPTION_MODEL,
  BALANCE_LIST_FILTER_OPTION_MODEL,
  BALANCE_LIST_SORT_OPTION_MODEL,
  BALANCE_INFO_MODEL,
  BALANCE_BRAND_LIST_SEARCH_OPTION_MODEL,
} from './models';
import { LIST_PAGINATION_MODEL, LIST_SUMMARY_MODEL } from '../app/models';
import { updateStoreWithPath } from '../../../lib/common';

/**
 *  INITIAL STATE
 */
const initialState = {
  balanceBrandList: {
    // 리스트
    list: [],
    // 리스트 pagination
    pagination: LIST_PAGINATION_MODEL,
    // 집계 데이터
    summary: LIST_SUMMARY_MODEL,
    // 검색 데이터
    searchData: BALANCE_BRAND_LIST_SEARCH_OPTION_MODEL,
    // 검색 옵션
    searchOption: BALANCE_BRAND_LIST_SEARCH_OPTION_MODEL,
  },

  balanceList: {
    /**
     *  리스트
     */
    list: [],
    /**
     *  선택된 정산 ID 리스트
     */
    checkedIdList: [],
    /**
     *  정산 집계
     */
    balanceSummaryBox: BALANCE_SUMMARY_BOX_MODEL,
    /**
     *  검색 데이터
     */
    searchData: BALANCE_LIST_SEARCH_DATA_MODEL,
    /**
     *  검색 옵션
     */
    searchOption: BALANCE_LIST_SEARCH_OPTION_MODEL,
    /**
     *  필터 옵션
     */
    filterOption: BALANCE_LIST_FILTER_OPTION_MODEL,
    /**
     *  정렬 옵션
     */
    sortOption: BALANCE_LIST_SORT_OPTION_MODEL,
    /**
     *  리스트 pagination
     */
    pagination: LIST_PAGINATION_MODEL,
    /**
     *  집계 데이터
     */
    summary: LIST_SUMMARY_MODEL,
  },

  balanceDetail: {
    /**
     *  정산 정보
     */
    balanceInfo: BALANCE_INFO_MODEL,

    /**
     *  정산 아이템 리스트
     */
    balanceItemList: [],
  },
};

/**
 *  REDUCER
 */
export default handleActions(
  {
    /**
     *  [정산 리스트] 정산 데이터 변경하기
     */
    [actions.SET_DATA]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath(action.payload.path, action.payload.value, draft);
      });
    },

    /**
     *  [정산 상세] 정산 상세 요청하기
     */
    [actions.GET_BALANCE_DETAIL_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  정산 상세
         */
        draft.balanceDetail = action.payload.balanceDetail;
      });
    },

    /**
     *  [정산 브랜드 리스트] 정산 브랜드 리스트 요청하기
     */
    [actions.GET_BALANCE_BRAND_LIST_SUCCESS]: (state, action) => {
      return produce(state, (draft) => {
        /**
         *  정산 브랜드 리스트
         */
        draft.balanceBrandList = {
          ...draft.balanceBrandList,
          ...action.payload.balanceBrandList,
        };
      });
    },

    /**
     * 모달 토글
     */
    [actions.TOGGLE_MODAL]: (state, action) => {
      return produce(state, (draft) => {
        updateStoreWithPath([action.payload.name, 'data'], action.payload.data, draft);
        updateStoreWithPath([action.payload.name, 'isOpen'], action.payload.value, draft);
      });
    },
  },
  initialState,
);
